/**
 * Helpers for the SUPERUSER "Generate Random Password" flow.
 * Cooldown is enforced by the backend (2 minutes); these helpers format UX copy.
 */

export const ADMIN_PASSWORD_GENERATE_COOLDOWN_SECONDS = 120

/**
 * Build a user-facing message when generate is blocked by cooldown.
 * Prefers server `message` / `retryAfterSeconds` when present.
 */
export function formatPasswordGenerateCooldownMessage(errorPayload) {
  const data =
    errorPayload?.response?.data ||
    errorPayload?.data ||
    errorPayload ||
    {}
  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim()
  }
  const retryAfterSeconds = Number(data.retryAfterSeconds)
  if (Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0) {
    const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60))
    return `A password was generated recently for this account. Please wait about ${minutes} minute(s) before generating again.`
  }
  return 'A password was generated recently for this account. Please wait about 2 minutes before generating again.'
}

export function isPasswordGenerateCooldownError(error) {
  const status = error?.response?.status
  const code = error?.response?.data?.code
  return status === 429 || code === 'PASSWORD_GENERATE_COOLDOWN'
}
